













import VueOptions from '@utils/VueOptions'
import DropdownFilter from '@ui/Filters/DropdownFilter'

settings =
  name: 'AudienceCreativeFilter'

  vue:
    props: ['target', 'actions', 'options']

    components: {
      DropdownFilter,
    }

    methods:
      hiApplyFilters: ->
        @actions.hiApplyFilters()

export default VueOptions.vue settings
